export const LESSON_STATUS = [
  { title: 'Lesson Assigned', value: 'assigned' },
  { title: 'Lesson Unassigned', value: 'unassigned' },
]
export const PERIOD_STATUS = [
  { title: 'Period Assigned', value: 'assigned' },
  { title: 'Period Unassigned', value: 'unassigned' },
]
